// extracted by mini-css-extract-plugin
export default {"erro":"styles_erro__ZIlQh"};